<template>
  <div id="header" :class="{loged: loged}">
    <div class="header-content">
      <h1 id="logo" @click="HomeLink('/')">
        <img src="https://cdn.fabricschina.com.cn/statics/pattern-design/images/logo.png" alt="LOGO">
      </h1>
      <div class="nav">
        <ul class="nav-list" v-if="navMenu">
          <li v-for="(item, index) in navMenu" class="nav-item" @mousemove="navMousemove(index)" @mouseleave="navMouseleave(index)" @click="navChange(item)" :class=" {active: item.sign===navSign}" :key="index">
            <!-- <router-link :to='item.path'>{{item.name}}</router-link> -->
            {{item.name}}
            <navDropdown v-if="item.child" :ref="'navDropdown'+index">
              <template v-slot:navDropdown>
                <ul class="nav-dropdown-menu">
                <li class="dropdown-item" @click.stop="navChange(item)" :class="{active: item.sign===navSign}" v-for="(item, index) in item.child" :key="item.name+index">{{item.name}}</li>
                </ul>
              </template>
            </navDropdown>
          </li>
        </ul>
      </div>
      <div class="header-user" v-if="loged">
        <ul class="list">
          <li class="user-name item" @mousemove="userMousemove" @mouseleave="userMouseleave">
            <div class="item-con">
              <p class="icon"><i>{{userName}}</i></p>
              <navDropdown :ref="'navDropdownUser'">
                <template v-slot:navDropdown>
                  <ul class="nav-dropdown-menu">
                  <li class="dropdown-item" @click.stop="pageLink('/competition/company')">
                    <p>{{language==='cn'?'企业信息':'Information'}}</p>
                  </li>
                  <li class="dropdown-item" @click.stop="loginOut">{{language==='cn'?'退出登录':'Log off'}}</li>
                  </ul>
                </template>
              </navDropdown>
            </div>
          </li>
        </ul>
      </div>
      <div class="header-user" v-else>
        <div class="login-register">
          <p class="login" @click="pageLink('/login')">
            <router-link to="/login">
              <span>登录</span>
            </router-link>
          </p>
          <p class="line">/</p>
          <p class="register" @click="pageLink('/register')">
            <router-link to="/register">
              <span>注册</span>
            </router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navMenu from "../../assets/nav"
import navDropdown from "../navDropdown.vue"
export default {
  components: {
    navDropdown
  },
  props: {
    loged: Boolean
  },
  data(){
    return {
      userName: "",
      language: "cn",
      navSign: "",
      navMenu: null
    }
  },
  watch: {
    "$store.state.language": function(){
      this.language = this.$store.state.language;
    },
    $route(e){
      this.navSign = e.meta.navSign;
    }
  },
  created () {
    this.language = this.$store.state.language?this.$store.state.language:"cn";
    this.userName = this.$store.state.userInfo?this.$store.state.userInfo.email.substr(0,1): ""
    this.navSign = this.$route.meta.navSign?this.$route.meta.navSign:"";
    this.navMenu = navMenu;
  },
  mounted () {

  },
  methods: {
    navChange(item){
      let path = item.path;
      if(this.language === "en"){
        path = "/en"+path
      }
      this.$router.push({
        path
      })
    },
    navMousemove(index){
      if(this.navMenu[index].child){
        let navDropdown = "navDropdown"+index;
        this.$refs[navDropdown][0].open()
      }
    },
    navMouseleave(index){
      if(this.navMenu[index].child){
        let navDropdown = "navDropdown"+index;
        this.$refs[navDropdown][0].close()
      }
    },
    userMousemove(){
      this.$refs.navDropdownUser.open()
    },
    userMouseleave(){
      this.$refs.navDropdownUser.close()
    },
    HomeLink(){
      if(this.language === "cn"){
        this.$router.push({
          path: "/"
        })
      }
    },
    pageLink(path){
      if(this.language === "en"){
        path = "/en"+path
      }
      this.$router.push({
        path: path
      })
    },
    loginOut(){
      localStorage.removeItem("userInfo");
      localStorage.removeItem("loginInfo");
      this.$store.commit("setUserInfo", '');
      if(this.language === "cn"){
        this.$router.push({
          path: "/"
        })
      }else{
        this.$router.push({
          path: "/en/login"
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  #header{
    top: 0;
    left: 0;
    width: 100%;
    height: 80px;
    color: #333;
    // border-bottom: 1px solid #F1F1F1;
    background-color: #fff;
    z-index: 50;
    .header-content{
      width: 1440px;
      padding: 0 40px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      background-color: #fff;
    }
  }
  #header.transparent-bg{
    position: absolute;
    background-color: transparent;
    border-bottom: none;
  }
  #logo{
    width: 54px;
    height: 51px;
    margin: 15px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .nav{
    flex-grow: 1;
    font-size: 18px;
    .nav-list{
      text-align: left;
      padding: 0 5px;
    }
  }
  .nav-item{
    display: inline-block;
    height: 80px;
    padding: 0 20px;
    line-height: 80px;
    position: relative;
    cursor: pointer;
    color: #666;
    font-weight: 300;
    a{
      color: #fff;
    }
    &::before{
      position: absolute;
      width: 100%;
      height: 1px;
      background-color: #537DEE;
      content: " ";
      top: 0;
      left: 0;
      display: none;
    }
    &:hover::before{
      display: block;
    }
  }
  .active.nav-item{
    color: #333;
    font-weight: 400;
  }
  .active.nav-item::after{
    display: block;
    content: " ";
    width: 24px;
    height: 2px;
    background-color: #537DEE;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
  .header-user{
    .list{
      .item{
        float: left;
        position: relative;
        height: 80px;
        line-height: 30px;
        padding: 25px 0;
        width: 90px;
        cursor: pointer;
        .item-con{
          height: 30px;
          border-left: 1px solid #f1f1f1;
        }
      }
      .item:nth-child(1){
        .item-con{
          border: none;
        }
      }
      .declare-record{
        margin: 0 20px;
        font-size: 18px;
        .recor-icon{
          width: 17px;
          height: 20px;
          margin: 5px auto;
          background: url("https://cdn.fabricschina.com.cn/statics/pattern-design/icon/record.png") no-repeat center center/100% 100%;
        }
      }
      .declare-record:hover{
        color: #537DEE;
        .recor-icon{
          background: url("https://cdn.fabricschina.com.cn/statics/pattern-design/icon/record-hover.png") no-repeat center center/100% 100%;
        }
      }
      .user-name{
        position: relative;
        &::after{
          content: " ";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 1px;
          background-color: #537DEE;
          display: none;
        }
        &:hover::after{
          display: block;
        }
        span{
          display: inline-block;
        }
        .icon{
          width: 50px;
          height: 30px;
          line-height: 29px;
          margin: 0 auto;
          border-radius: 15px;
          background: #D51819;
          font-size: 18px;
          color: #fff;
          padding-right: 20px;
          background: url("https://cdn.fabricschina.com.cn/statics/DPI/icon/xia.png") no-repeat center right/10px 10px;
          i{
            display: inline-block;
            width: 30px;
            height: 30px;
            border-radius: 15px;
            background: #D51819;
          }
        }
      }
    }
    .login-register{
      line-height: 80px;
      font-size: 20px;
      p{
        cursor: pointer;
        margin: 0 1px;
        float: left;
      }
    }
  }
</style>
